import * as React from 'react'
import { MainBlock } from '@blocks/BlockMain/model'
import { DisclaimerMain } from '@shared/components/disclaimer-main'

export const ipotekaBezDohodaMainBlock: MainBlock = {
	title: 'Ипотека без подтверждения дохода в %city_pr%',
	// subtitle: 'Получите деньги на покупку квартиры быстро и без походов в офис',
	textItems: ['От 4,5% годовых', 'Одобрение суммы до 20 млн рублей', 'Срок — до 30 лет'],
	buttonText: 'Оставить заявку',
	footDisclaimer: <DisclaimerMain />,
	faceImageName: {
		mobile: 'ipotekaMobile.png',
		tablet: 'ipotekaTablet.png',
		default: 'ipoteka.png',
	},
	imageAlt: 'Владимир Холодилов, руководитель отдела по работе с клиентами',
}
